import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import PageLoadingSkeleton from 'Components/skeletons/PageLoadingSkeleton';
// import routes from './routes';
import AppRouter from './routes.config';
// import Snackbar from './components/global/CustomSnackbar'
const _ = require('lodash');
import { useIsAuthenticated } from '@azure/msal-react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

function App() {
  // const routing = useRoutes(routes());
  // TODO: remove the following line after testing
  // const routing = useRoutes(AppRouter());

  const isAuthenticated = useIsAuthenticated();
  // const k = useRequestAccessToken();
  // const authData = getAuth();
  // const { instance, accounts, inProgress } = useMsal();

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     // getAccessToken()
  //     // token logic from msal
  //     instance
  //       .acquireTokenSilent({
  //         scopes: ['User.Read'],
  //         account: accounts[0]
  //       })
  //       .then((res) => console.log('toke response: ', res));
  //   } else {
  //     // msal insance login redirect call
  //   }
  //   console.log(isAuthenticated);
  // }, [isAuthenticated, authData?.accessToken]);

  return (
    <React.StrictMode>
      <Suspense
        fallback={
          <PageLoadingSkeleton
            variant='rectangular'
            marginx={1}
            marginy={1}
            count={1}
            height={700}
          />
        }
      >
        {/* <Snackbar /> */}
        {/* {routing} */}
        <AppRouter />
      </Suspense>
    </React.StrictMode>
  );

  // return (
  //   // <React.StrictMode>
  //   <RouterProvider router={router} />
  //   // </React.StrictMode>
  // );
}

export default App;
